var render, staticRenderFns
import script from "./lb-render.vue?vue&type=script&lang=js"
export * from "./lb-render.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c953a05')) {
      api.createRecord('0c953a05', component.options)
    } else {
      api.reload('0c953a05', component.options)
    }
    
  }
}
component.options.__file = "src/components/lb-table/lb-render.vue"
export default component.exports